export default "__VITE_PUBLIC_ASSET__dde21afd__"